import type { IntlShape } from 'react-intl'

const staticAppTextFormatters: Record<string, (intl: IntlShape) => string> = {
  'Australia': (intl) => intl.formatMessage({
    id: 'S1oajVah8hhEnNCM4DPb',
    defaultMessage: 'Australia',
    description: 'Config-driven destination label for Australia shown in footer, sidebar, or destination link surfaces',
  }),
  'Bali': (intl) => intl.formatMessage({
    id: 'WOyA5RqIk5UVg5lZLvYJ',
    defaultMessage: 'Bali',
    description: 'Config-driven destination label for Bali shown in footer, sidebar, or destination link surfaces',
  }),
  'Best of 2025': (intl) => intl.formatMessage({
    id: 'ZQIBUxdPXNTvBU-iQvzm',
    defaultMessage: 'Best of 2025',
    description: 'Config-driven label for the Best of 2025 campaign link shown in shared navigation surfaces',
  }),
  'Business Travel': (intl) => intl.formatMessage({
    id: '16puE9f3VvqdIi--y81T',
    defaultMessage: 'Business Travel',
    description: 'Config-driven label for the business travel link shown in shared navigation surfaces',
  }),
  'California': (intl) => intl.formatMessage({
    id: 'fEZKf2ZZ2jhP6TTkQzAH',
    defaultMessage: 'California',
    description: 'Config-driven destination label for California shown in footer, sidebar, or destination link surfaces',
  }),
  'Car Hire': (intl) => intl.formatMessage({
    id: '8ZwA9-ddQCEbp-_wRZZa',
    defaultMessage: 'Car Hire',
    description: 'Config-driven label for the car hire link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Cruises': (intl) => intl.formatMessage({
    id: 'gGAv1vuigbVBK6XhAtiL',
    defaultMessage: 'Cruises',
    description: 'Config-driven label for the cruises link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Cudo': (intl) => intl.formatMessage({
    id: 'Zwchbeoqwc48yfF2CWqO',
    defaultMessage: 'Cudo',
    description: 'Config-driven partner brand label for Cudo shown in footer or partner-brand surfaces',
  }),
  'Deals': (intl) => intl.formatMessage({
    id: 'o7y1P2ZJe2cveNsm8hIv',
    defaultMessage: 'Deals',
    description: 'Config-driven partner brand label for Deals shown in footer or partner-brand surfaces',
  }),
  'Direct Maldives Flights': (intl) => intl.formatMessage({
    id: 'KjN2E89ePMc3CPA4jN-Z',
    defaultMessage: 'Direct Maldives Flights',
    description: 'Config-driven label for the direct Maldives flights link shown in shared navigation surfaces',
  }),
  'Europe': (intl) => intl.formatMessage({
    id: 'vxD8BB_rOSckGxbIE8TN',
    defaultMessage: 'Europe',
    description: 'Config-driven destination label for Europe shown in footer, sidebar, or destination link surfaces',
  }),
  'Experiences': (intl) => intl.formatMessage({
    id: 'kGv7JMD3Z3LNdQCA6K9r',
    defaultMessage: 'Experiences',
    description: 'Config-driven label for the experiences link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Fiji': (intl) => intl.formatMessage({
    id: 'ABamS609BY-BnSqrdPHC',
    defaultMessage: 'Fiji',
    description: 'Config-driven destination label for Fiji shown in footer, sidebar, or destination link surfaces',
  }),
  'Flights': (intl) => intl.formatMessage({
    id: 'rjkAgXNqcXA47CAL9sAD',
    defaultMessage: 'Flights',
    description: 'Config-driven label for the flights link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Gift Cards': (intl) => intl.formatMessage({
    id: 'Fdyo8GZ5KQkWvc75vhh_',
    defaultMessage: 'Gift Cards',
    description: 'Config-driven label for the gift cards link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Golf': (intl) => intl.formatMessage({
    id: 'nuEE-728_wfga96BmVdb',
    defaultMessage: 'Golf',
    description: 'Config-driven label for the golf link shown in shared navigation surfaces',
  }),
  'Groups': (intl) => intl.formatMessage({
    id: 'a-Ry45gISOQOTFqvRBKz',
    defaultMessage: 'Groups',
    description: 'Config-driven label for the groups link shown in shared navigation or footer surfaces',
  }),
  'Hawaii': (intl) => intl.formatMessage({
    id: 'FzHeDjXxCI80h5M_pALg',
    defaultMessage: 'Hawaii',
    description: 'Config-driven destination label for Hawaii shown in footer, sidebar, or destination link surfaces',
  }),
  'Holidays': (intl) => intl.formatMessage({
    id: 'mpbKIx7c9XM79v5UeRYu',
    defaultMessage: 'Holidays',
    description: 'Config-driven label for the holidays link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Home': (intl) => intl.formatMessage({
    id: 'j-noXtNNi7Kqihb9Fr1h',
    defaultMessage: 'Home',
    description: 'Config-driven label for the home link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Homes & Villas': (intl) => intl.formatMessage({
    id: '9FgjGNcJvHHrI0F8fEDp',
    defaultMessage: 'Homes & Villas',
    description: 'Config-driven label for the homes and villas link shown in shared navigation surfaces',
  }),
  'Hong Kong': (intl) => intl.formatMessage({
    id: 'sLuGhIDb-pnS_Ng3MtV4',
    defaultMessage: 'Hong Kong',
    description: 'Config-driven destination label for Hong Kong shown in footer, sidebar, or destination link surfaces',
  }),
  'Hotels': (intl) => intl.formatMessage({
    id: 'Du7wu76EAhcUNe7aYRrW',
    defaultMessage: 'Hotels',
    description: 'Config-driven label for the hotels link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Hotels & Resorts': (intl) => intl.formatMessage({
    id: 'hlNqY6uTwK8zCnHbuT-t',
    defaultMessage: 'Hotels & Resorts',
    description: 'Config-driven label for the hotels and resorts link shown in shared navigation or sidebar surfaces',
  }),
  'Inspiration': (intl) => intl.formatMessage({
    id: 'SCxm4dKRDfsQ5WcVPKtr',
    defaultMessage: 'Inspiration',
    description: 'Config-driven label for the inspiration link shown in shared navigation surfaces',
  }),
  'Japan': (intl) => intl.formatMessage({
    id: 'qxileo8AaoTRFTFwINal',
    defaultMessage: 'Japan',
    description: 'Config-driven destination label for Japan shown in footer, sidebar, or destination link surfaces',
  }),
  'LuxPlus+': (intl) => intl.formatMessage({
    id: 't1VsvOs4hSp9vtiZ85XS',
    defaultMessage: 'LuxPlus+',
    description: 'Config-driven label for the LuxPlus+ membership program shown in shared navigation or account surfaces',
  }),
  'Luxury Escapes Live': (intl) => intl.formatMessage({
    id: 'G0degzEJnmpQKo9mcTSD',
    defaultMessage: 'Luxury Escapes Live',
    description: 'Config-driven label for the Luxury Escapes Live event shown in shared navigation surfaces',
  }),
  'Maldives': (intl) => intl.formatMessage({
    id: 'NtfGeH6ION4a3nMwtqB9',
    defaultMessage: 'Maldives',
    description: 'Config-driven destination label for the Maldives shown in footer, sidebar, or destination link surfaces',
  }),
  'Maldives Bundles': (intl) => intl.formatMessage({
    id: 'YVAOYUDUw_0ZiP7xa-Fs',
    defaultMessage: 'Maldives Bundles',
    description: 'Config-driven label for the Maldives bundles campaign link shown in shared navigation surfaces',
  }),
  'More': (intl) => intl.formatMessage({
    id: 'iogTL25pepF33WNv_kzn',
    defaultMessage: 'More',
    description: 'Config-driven label for the more dropdown shown in shared navigation surfaces',
  }),
  'New Zealand': (intl) => intl.formatMessage({
    id: '8LyMQb4J4an8SKgCUm6q',
    defaultMessage: 'New Zealand',
    description: 'Config-driven destination label for New Zealand shown in footer, sidebar, or destination link surfaces',
  }),
  'Refer a Friend': (intl) => intl.formatMessage({
    id: '1ibiA1tK4QuLynM1avt9',
    defaultMessage: 'Refer a Friend',
    description: 'Config-driven label for the refer-a-friend link shown in shared navigation surfaces',
  }),
  'Scoopon': (intl) => intl.formatMessage({
    id: '2U2DxbcGZdlBbHSmq7_M',
    defaultMessage: 'Scoopon',
    description: 'Config-driven partner brand label for Scoopon shown in footer or partner-brand surfaces',
  }),
  'Shop': (intl) => intl.formatMessage({
    id: 'h7dyYt-ykomT2vTkJyCO',
    defaultMessage: 'Shop',
    description: 'Config-driven label for the shop or marketplace link shown in shared navigation surfaces',
  }),
  'Singapore': (intl) => intl.formatMessage({
    id: 'XCNcq4pVg1kGdHvK4fen',
    defaultMessage: 'Singapore',
    description: 'Config-driven destination label for Singapore shown in footer, sidebar, or destination link surfaces',
  }),
  'Société': (intl) => intl.formatMessage({
    id: 'yUDJ6xWCQUgwyOFcurqS',
    defaultMessage: 'Société',
    description: 'Config-driven label for the Société loyalty program shown in shared navigation surfaces',
  }),
  'South Pacific': (intl) => intl.formatMessage({
    id: 'mQa2fvcicTHfOWz3AMZu',
    defaultMessage: 'South Pacific',
    description: 'Config-driven destination label for the South Pacific shown in footer, sidebar, or destination link surfaces',
  }),
  'Support': (intl) => intl.formatMessage({
    id: '9QaG60nE3rpbHlBuAlFK',
    defaultMessage: 'Support',
    description: 'Config-driven label for the support link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Thailand': (intl) => intl.formatMessage({
    id: 'Xgn83DWbXDLdcqaZIpY7',
    defaultMessage: 'Thailand',
    description: 'Config-driven destination label for Thailand shown in footer, sidebar, or destination link surfaces',
  }),
  'Tours': (intl) => intl.formatMessage({
    id: 'yOTXLZhiQJuObKxhBiJI',
    defaultMessage: 'Tours',
    description: 'Config-driven label for the tours link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Tours & Cruises': (intl) => intl.formatMessage({
    id: 'PQNDf9pmC-Df0AIS_TSF',
    defaultMessage: 'Tours & Cruises',
    description: 'Config-driven label for the combined tours and cruises link shown in shared navigation surfaces',
  }),
  'Travel Protection': (intl) => intl.formatMessage({
    id: 'qnb-VRE3XIXz11_ZWiFY',
    defaultMessage: 'Travel Protection',
    description: 'Config-driven label for the travel protection link shown in shared navigation surfaces',
  }),
  'Travelshoot': (intl) => intl.formatMessage({
    id: 'wR5CkMsrZ7fHOEvaoVXj',
    defaultMessage: 'Travelshoot',
    description: 'Config-driven partner brand label for Travelshoot shown in footer or partner-brand surfaces',
  }),
  'Treat Me': (intl) => intl.formatMessage({
    id: 'x8tkc_CPqs1vW84wWzN0',
    defaultMessage: 'Treat Me',
    description: 'Config-driven partner brand label for Treat Me shown in footer or partner-brand surfaces',
  }),
  'Ultra Lux': (intl) => intl.formatMessage({
    id: 'J7UdomXHkCph_5dLGjHm',
    defaultMessage: 'Ultra Lux',
    description: 'Config-driven label for the Ultra Lux product link shown in shared navigation surfaces',
  }),
  'Vietnam': (intl) => intl.formatMessage({
    id: '4bS7KqwvXEnp5Z2AbSd_',
    defaultMessage: 'Vietnam',
    description: 'Config-driven destination label for Vietnam shown in footer, sidebar, or destination link surfaces',
  }),
  'Visit Us In Store': (intl) => intl.formatMessage({
    id: 'OJY-V8ElE34mYkQ3bxv6',
    defaultMessage: 'Visit Us In Store',
    description: 'Config-driven label for the in-store visit link shown in shared navigation surfaces',
  }),
  'Weddings': (intl) => intl.formatMessage({
    id: 'NacytM3o5VYlYkVIKrLJ',
    defaultMessage: 'Weddings',
    description: 'Config-driven label for the weddings link shown in shared navigation or footer surfaces',
  }),
}

export default function formatStaticAppText(intl: IntlShape, text: string): string {
  return staticAppTextFormatters[text]?.(intl) ?? text
}
